export default {
  state: {
    contentItems: {},
  },
  mutations: {
    createContentItemEditor(state, contentItem) {
      state.contentItems[contentItem.editorId] = contentItem;
    },
    deleteContentItemEditor(state, editorId) {
      delete state.contentItems[editorId];
    },
    updateContentItemEditorTitle(state, payload) {
      state.contentItems[payload.editorId].title = payload.title;
    },
    updateContentItemEditorDescription(state, payload) {
      state.contentItems[payload.editorId].description = payload.description;
    },
    swapContentItemEditorRelativeOrders(state, payload) {
      let tempRelativeOrder = state.contentItems[payload.editorIdA].relativeOrder;
      state.contentItems[payload.editorIdA].relativeOrder = state.contentItems[payload.editorIdB].relativeOrder;
      state.contentItems[payload.editorIdB].relativeOrder = tempRelativeOrder;
    },
  },
};
